import styled from 'styled-components';
import { Modal } from '../../atoms/Modal';

export const StyledModal = styled(Modal)`
  width: 100vw;
  height: 100vh;
  max-height: 100vh;

  & .content {
    max-height: calc(100vh - 58px);
    overflow-y: auto;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.div`
  padding-bottom: 16px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding-left: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
`;

export const Title = styled.h3`
  flex: 1;
  margin: 0;
  line-height: 50px;
  font-size: 1rem;
`;

export const SquareButton = styled.button`
  height: 50px;
  width: 50px;
  border: 0;
  outline: 0;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }

  & svg {
    height: 50%;
    & > path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const CloseButton = styled(SquareButton)`
  & svg {
    height: 50%;
  }
`;

export const Actions = styled.div`
  display: flex;
  padding-right: 0.5rem;
`;
